import { ScaledSheet } from 'react-native-size-matters/extend';

export const createStyles =
  (callback) => 
      ScaledSheet.create(callback());

